/**
 * Route guard for the DPDP consent gate.
 *
 * The real gate is a database trigger, so this is purely about kindness: a
 * learner under 18 whose guardian hasn't consented yet is walked to the
 * consent step instead of into writes that will be refused.
 */
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useConsentState, consentRedirect } from "@/lib/consentGate";

export default function ConsentGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { state, loading } = useConsentState();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" role="status" aria-live="polite">
        <Loader2 className="h-6 w-6 animate-spin text-primary" aria-hidden="true" />
        <span className="sr-only">Checking your Passport…</span>
      </div>
    );
  }

  const to = consentRedirect(state, `${location.pathname}${location.search}`);
  if (to) return <Navigate to={to} replace />;

  return <>{children}</>;
}
